import { Label } from "@/components/Base/Label";
import { EditSaveTime } from "@/components/Common/EditSaveTime";
import { format, parse } from "date-fns";
import {
  DEFAULT_WORKING_HOURS_END,
  DEFAULT_WORKING_HOURS_START,
} from "@/lib/const";
import { useStore } from "@/stores/useStore";
import { WorkingDay } from "@/types/v2";
import { shop } from "@/repositories/shop";
import { buildWorkingHours } from "@/lib/workingHours";
import { showErrorToast } from "@/lib/toast";

export const ShopConfiguration = () => {
  const shopData = useStore((s) => s.shop);

  const handleSaveWorkingHours = async (
    key: keyof Omit<WorkingDay, "isClosed">,
    value: string
  ) => {
    if (!shopData?.id) return;

    const nextWorkingHours = buildWorkingHours(
      shopData.shopConfig?.workingHours,
      key,
      value
    );

    try {
      await shop.update(shopData.id, {
        shopConfig: { ...shopData.shopConfig, workingHours: nextWorkingHours },
      });
    } catch {
      showErrorToast("Couldn't save working hours", "Please try again.");
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <Label className={"text-lg"}>Working Hours</Label>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"workingHoursStart"}>
          Start:
        </Label>
        <EditSaveTime
          value={parse(
            shopData?.shopConfig?.workingHours?.Monday.startTime ??
              DEFAULT_WORKING_HOURS_START,
            "HH:mm",
            new Date()
          )}
          onSave={(value) =>
            handleSaveWorkingHours(
              "startTime",
              format(value ?? DEFAULT_WORKING_HOURS_START, "HH:mm")
            )
          }
          options={{ hour12: true }}
        />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Label className={"w-28"} htmlFor={"workingHoursEnd"}>
          End:
        </Label>
        <EditSaveTime
          value={parse(
            shopData?.shopConfig?.workingHours?.Monday.endTime ??
              DEFAULT_WORKING_HOURS_END,
            "HH:mm",
            new Date()
          )}
          onSave={(value) =>
            handleSaveWorkingHours(
              "endTime",
              format(value ?? DEFAULT_WORKING_HOURS_END, "HH:mm")
            )
          }
          options={{ hour12: true }}
        />
      </div>
    </div>
  );
};
